// src/components/WorldRing.tsx
import { COUNTRIES, SDG, flag } from './flags'

// r = ring radius, n = flags on ring, s = flag size (all in % of the container)
const RINGS = [
  { r: 27, n: 25, s: 5.6, rev: false },
  { r: 34.5, n: 33, s: 5.2, rev: true },
  { r: 42, n: 41, s: 4.8, rev: false },
]

const spin = 'animate-[spin_120s_linear_infinite] motion-reduce:animate-none'
const spinRev = `${spin} [animation-direction:reverse]`

function polar(r: number, deg: number) {
  const a = ((deg - 90) * Math.PI) / 180
  return { x: 50 + r * Math.cos(a), y: 50 + r * Math.sin(a) }
}

function sdgArcs() {
  const step = 360 / SDG.length
  return SDG.map((c, i) => {
    const p1 = polar(48, i * step + 1.4)
    const p2 = polar(48, (i + 1) * step - 1.4)
    return (
      <path
        key={c}
        d={`M${p1.x} ${p1.y} A48 48 0 0 1 ${p2.x} ${p2.y}`}
        stroke={c}
        strokeWidth="3.6"
        fill="none"
      />
    )
  })
}

export default function WorldRing({ className = '' }: { className?: string }) {
  let idx = 0
  return (
    <div className={`relative aspect-square ${className}`}>
      {/* SDG colour ring + dashed guide */}
      <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full" aria-hidden>
        <circle cx="50" cy="50" r="49.6" fill="none" stroke="#9DB8E8" strokeWidth="0.25" strokeDasharray="1 1.4" />
        {sdgArcs()}
        <circle cx="50" cy="50" r="45" fill="#EEF4FE" opacity="0.7" />
      </svg>

      {/* Flag rings */}
      {RINGS.map((ring, ri) => (
        <div key={ri} className={`absolute inset-0 will-change-transform ${ring.rev ? spinRev : spin}`}>
          {Array.from({ length: ring.n }).map((_, i) => {
            const code = COUNTRIES[idx++ % COUNTRIES.length]
            const { x, y } = polar(ring.r, (i / ring.n) * 360 + ri * 7)
            return (
              <div
                key={code}
                className="absolute aspect-square -translate-x-1/2 -translate-y-1/2"
                style={{ left: `${x}%`, top: `${y}%`, width: `${ring.s}%` }}
              >
                {/* counter-rotate so flags stay upright */}
                <div className={`h-full w-full ${ring.rev ? spin : spinRev}`}>
                  <img
                    src={flag(code)}
                    alt=""
                    draggable={false}
                    className="h-full w-full rounded-full object-cover shadow ring-[1.5px] ring-white"
                  />
                </div>
              </div>
            )
          })}
        </div>
      ))}

      {/* Centre badge (SVG so the text scales with the ring) */}
      <svg viewBox="0 0 100 100" className="absolute left-[27%] top-[27%] z-10 h-[46%] w-[46%] drop-shadow-xl" aria-hidden>
        <defs>
          <linearGradient id="badge" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#24357F" />
            <stop offset="1" stopColor="#141F55" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r="49" fill="url(#badge)" stroke="#fff" strokeWidth="1.5" />
        <text x="50" y="58" textAnchor="middle" fontSize="38" fontWeight="900" fill="#F59E0B">99</text>
        <text x="50" y="71" textAnchor="middle" fontSize="7" fontWeight="700" letterSpacing="2" fill="#fff">COUNTRIES</text>
        <text x="50" y="80" textAnchor="middle" fontSize="4.4" letterSpacing="1.4" fill="#BFD3F5">ONE EXPERIENCE</text>
      </svg>

      {/* Host nation: Malaysia, with glow */}
      <div className="absolute left-1/2 top-0 z-20 aspect-square w-[15%] -translate-x-1/2 -translate-y-[35%]">
        <div className="absolute -inset-[14%] rounded-full bg-amber-300/60 blur-md" />
        <img
          src={flag('my', 160)}
          alt="Malaysia"
          draggable={false}
          className="relative h-full w-full rounded-full object-cover ring-[3px] ring-white shadow-lg"
        />
      </div>
    </div>
  )
}
